import React, { useState, useEffect, useContext, Suspense } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { GlobalContext } from "@Context/context/GlobalState"
import { AuthContext } from "@Context/context/AuthContext"
import LocalShippingIcon from "@material-ui/icons/LocalShipping"
import { getCoverage } from "@Services/coverageService"
import { useTranslation } from "react-i18next"
import useUserPermissions from "@Hooks/useUserPermissions"
import rsc from "@Config/resources"
import { useHistory } from "react-router"

import { LoadComponentByCondition } from "@Methods"
const Component = new LoadComponentByCondition("FormCoverage").render()

const EditCoverageScreen = () => {
  const { user } = useContext(AuthContext)
  const { handleRoutingBreadcrumbs, handleErrorSession } =
    useContext(GlobalContext)
  const { coverageId } = useParams()
  const [load, setLoad] = useState(true)
  const [info, setInfo] = useState({})
  const { t } = useTranslation("global")
  const { permission, checking } = useUserPermissions({
    resources: [rsc.CoCrudEditCoverage],
  })
  const history = useHistory()

  useEffect(() => {
    if (!checking) {
      if (!permission[rsc.CoCrudEditCoverage]) return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checking])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("edit-coverage"),
      routes: [
        { name: t("logistics"), route: "/coverage" },
        { name: t("edit-coverage"), route: `/coverage/edit/${coverageId}` },
      ],
      icon: <LocalShippingIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    getCoverageAction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCoverageAction = async () => {
    try {
      let response = await getCoverage(user.user.token, {
        skipRecords: 0,
        maxRecords: 1,
        filter: { id: coverageId },
      })
      if (response?.data?.message?.totalRecordsMatched) {
        setInfo(response?.data?.message?.records[0] || {})
        setLoad(false)
      }
    } catch (error) {
      handleErrorSession({
        error: true,
        errorCode: error.response.status,
        messageError: error?.response?.data?.message,
      })
    }
  }

  return (
    <Suspense fallback>
      <Component load={load} edit={true} coverage={info} />
    </Suspense>
  )
}

export default EditCoverageScreen
